export default [
  { title: "Home", text: "Home" },
  { title: "Radar", text: "Radar" },
  { title: "Flood", text: "Flood-Data" },
];
